import { z } from "zod";

export const createUserSchema = z.object({
  first_name: z.string().min(1, "Por favor ingresa el nombre del usuario"),
  last_name: z.string().min(1, "Por favor ingresa los apellidos del usuario"),
  email: z
    .string()
    .min(1, "El correo electrónico es requerido")
    .email("El correo no tiene un formato válido"),
  phone: z
    .string()
    .optional()
    .refine(
      (value) => {
        if (!value) return true;
        return /^\+\d{7,15}$/.test(value);
      },
      {
        message: "El número debe tener entre 7 y 15 dígitos",
      },
    ),
});

export type CreateUserSchema = z.infer<typeof createUserSchema>;
